export default {"src":"/_next/static/media/google-cloud-logo-122-20.2b58bbcf.svg","height":20,"width":122};